/** Quote every cell so commas, quotes and newlines survive Excel/Sheets import. */
const escapeCell = (value: unknown): string =>
  `"${String(value ?? "")
    .replace(/\r?\n/g, " ")
    .replace(/"/g, '""')}"`

export function toCsv(headers: string[], rows: unknown[][]): string {
  return [headers, ...rows].map(row => row.map(escapeCell).join(",")).join("\n")
}

/** Trigger a browser download of a CSV built from `headers` + `rows`. */
export function downloadCsv(
  filename: string,
  headers: string[],
  rows: unknown[][],
): void {
  const blob = new Blob([toCsv(headers, rows)], {
    type: "text/csv;charset=utf-8",
  })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement("a")
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
